import { render, staticRenderFns } from "./beef.vue?vue&type=template&id=05451784&scoped=true"
import script from "./beef.vue?vue&type=script&lang=js"
export * from "./beef.vue?vue&type=script&lang=js"
import style0 from "./beef.vue?vue&type=style&index=0&id=05451784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05451784",
  null
  
)

export default component.exports